import type { KneelResponseOptionIdType } from '../types';

export const getKneelResponse = (
  kneelResponse: KneelResponseOptionIdType | null,
): KneelResponseOptionIdType | null => {
  return kneelResponse;
};
